/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandOrderingConfigurationRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandOrderingConfigurationResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandOrderingConfiguration = (request: SetBrandOrderingConfigurationRequest, options?: CashRequestOptions) => post<SetBrandOrderingConfigurationRequest, SetBrandOrderingConfigurationResponse>("/2.0/cash/set-brand-ordering-configuration", request, {...options, rejectOnError: true })